document.addEventListener("DOMContentLoaded", () => {
  const drawer = document.querySelector("[data-cart-drawer]");
  const content = document.querySelector("[data-cart-content]");

  const openDrawer = async () => {
    drawer?.setAttribute("aria-hidden", "false");
    if (!content) return;
    content.innerHTML = "<p class='cart-empty'>Loading your bag…</p>";
    try {
      const response = await fetch("/cart.js");
      if (!response.ok) throw new Error("Cart request failed");
      const cart = await response.json();
      if (!cart.item_count) {
        content.innerHTML = "<p class='cart-empty'>Your bag is ready when you are.</p>";
        return;
      }
      const money = (cents) => window.Shopify?.formatMoney ? window.Shopify.formatMoney(cents) : `$${(cents / 100).toFixed(2)}`;
      content.innerHTML = `${cart.items.map((item) => `<div class="cart-line"><img src="${item.image || ""}" alt="${item.product_title || ""}"><div><strong>${item.product_title}</strong><p>${item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : ""}</p><p>${item.quantity} × ${money(item.final_price)}</p></div></div>`).join("")}<div class="cart-summary"><div class="cart-summary__row"><span>Subtotal</span><span>${money(cart.total_price)}</span></div><a class="button" href="/checkout">Secure checkout</a></div>`;
    } catch {
      content.innerHTML = "<p class='cart-empty'>We couldn’t load your bag. Please try again.</p>";
    }
  };

  document.querySelectorAll("[data-cart-open]").forEach((button) => button.addEventListener("click", openDrawer));
  document.querySelectorAll("[data-cart-close]").forEach((button) => button.addEventListener("click", () => drawer?.setAttribute("aria-hidden", "true")));
  document.querySelectorAll("[data-accordion-button]").forEach((button) => button.addEventListener("click", () => {
    const body = document.getElementById(button.getAttribute("aria-controls"));
    if (!body) return;
    const expanded = button.getAttribute("aria-expanded") === "true";
    button.setAttribute("aria-expanded", String(!expanded));
    body.hidden = expanded;
  }));

  document.querySelectorAll("[data-sunday-subscription]").forEach((selector) => {
    const sellingPlanInput = selector.querySelector("[data-selling-plan-input]");
    const options = Array.from(selector.querySelectorAll("[data-purchase-option]"));
    const updatePurchaseOption = () => {
      const selected = options.find((option) => option.checked);
      if (!selected || !sellingPlanInput) return;
      sellingPlanInput.value = selected.dataset.sellingPlanId || "";
      selector.querySelectorAll("[data-subscription-option]").forEach((option) => {
        option.classList.toggle("is-selected", option.contains(selected));
      });
    };
    options.forEach((option) => option.addEventListener("change", updatePurchaseOption));
    updatePurchaseOption();
  });

  const mainProductForm = document.querySelector(".product-form");
  const mobileStickyBuy = document.querySelector("[data-mobile-sticky-buy]");
  const mobileAddToBag = document.querySelector("[data-mobile-add-to-bag]");
  const mobilePurchaseLabel = document.querySelector("[data-mobile-purchase-label]");
  const mobilePurchasePrice = document.querySelector("[data-mobile-purchase-price]");

  const syncMobilePurchase = () => {
    if (!mainProductForm || !mobileStickyBuy) return;
    const selected = mainProductForm.querySelector("[data-purchase-option]:checked");
    const selectedCard = selected?.closest("[data-subscription-option]");
    if (!selectedCard) return;
    if (mobilePurchaseLabel) mobilePurchaseLabel.textContent = selectedCard.querySelector("strong")?.textContent || "One-time purchase";
    if (mobilePurchasePrice) mobilePurchasePrice.textContent = selectedCard.querySelector(".sunday-subscription__price")?.textContent || "";
  };

  if (mainProductForm && mobileStickyBuy) {
    mainProductForm.querySelectorAll("[data-purchase-option]").forEach((option) => option.addEventListener("change", syncMobilePurchase));
    mobileAddToBag?.addEventListener("click", () => mainProductForm.requestSubmit());
    syncMobilePurchase();
  }

  const mobileProductQuery = window.matchMedia("(max-width: 700px)");
  const reviewBlock = document.querySelector(".product-gallery__reviews");
  const purchaseOptions = document.querySelector("[data-sunday-subscription]");
  const whyAccordion = document.querySelector("[id^='Why-']")?.closest(".accordion");
  const productDetail = document.querySelector(".product-detail");
  const productKicker = productDetail?.querySelector(":scope > .section-kicker");
  const reviewLink = productDetail?.querySelector(":scope > .product-review-link");
  const productIntro = productDetail?.querySelector(":scope > .product-detail__intro");
  const pricingBlock = productDetail?.querySelector(":scope > .product-detail__pricing");
  const goalBlock = productDetail?.querySelector(":scope > .product-goals");
  const benefitsBlock = productDetail?.querySelector(":scope > .product-detail__benefits");
  const quantityInput = mainProductForm?.querySelector(".quantity-input");
  const productSubmit = mainProductForm?.querySelector(".product-form__submit");
  const acceleratedCheckout = mainProductForm?.querySelector(".shopify-payment-button");
  const checkoutNote = productDetail?.querySelector(":scope > .product-detail__checkout-note");
  const reviewHome = reviewBlock?.parentNode;
  const reviewHomeNext = reviewBlock?.nextSibling;
  const whyHome = whyAccordion?.parentNode;
  const whyHomeNext = whyAccordion?.nextSibling;
  const pricingHome = pricingBlock?.parentNode;
  const pricingHomeNext = pricingBlock?.nextSibling;
  const goalHome = goalBlock?.parentNode;
  const goalHomeNext = goalBlock?.nextSibling;
  const benefitsHome = benefitsBlock?.parentNode;
  const benefitsHomeNext = benefitsBlock?.nextSibling;

  const arrangeMobileProductDetail = () => {
    if (!reviewBlock || !purchaseOptions || !whyAccordion || !productDetail) return;
    if (mobileProductQuery.matches) {
      productKicker?.setAttribute("hidden", "");
      reviewLink?.setAttribute("hidden", "");
      if (pricingBlock && productIntro) productDetail.insertBefore(pricingBlock, productIntro);
      purchaseOptions.insertAdjacentElement("afterend", reviewBlock);
      reviewBlock.insertAdjacentElement("afterend", whyAccordion);
      if (goalBlock) whyAccordion.insertAdjacentElement("afterend", goalBlock);
      if (benefitsBlock) goalBlock ? goalBlock.insertAdjacentElement("afterend", benefitsBlock) : whyAccordion.insertAdjacentElement("afterend", benefitsBlock);
      [whyAccordion, goalBlock, benefitsBlock, quantityInput, productSubmit, acceleratedCheckout, checkoutNote].forEach((block) => block?.setAttribute("hidden", ""));
      return;
    }
    productKicker?.removeAttribute("hidden");
    reviewLink?.removeAttribute("hidden");
    [whyAccordion, goalBlock, benefitsBlock, quantityInput, productSubmit, acceleratedCheckout, checkoutNote].forEach((block) => block?.removeAttribute("hidden"));
    if (reviewHome) reviewHome.insertBefore(reviewBlock, reviewHomeNext);
    if (whyHome) whyHome.insertBefore(whyAccordion, whyHomeNext);
    if (pricingHome) pricingHome.insertBefore(pricingBlock, pricingHomeNext);
    if (goalHome) goalHome.insertBefore(goalBlock, goalHomeNext);
    if (benefitsHome) benefitsHome.insertBefore(benefitsBlock, benefitsHomeNext);
  };

  const alignSecondaryProductSections = () => {
    document.querySelectorAll(".faq-section, .product-related").forEach((section) => {
      section.style.maxWidth = mobileProductQuery.matches ? "" : "1320px";
      section.style.marginLeft = "auto";
      section.style.marginRight = "auto";
      section.style.paddingLeft = mobileProductQuery.matches ? "24px" : "72px";
      section.style.paddingRight = mobileProductQuery.matches ? "24px" : "72px";
    });
  };

  arrangeMobileProductDetail();
  alignSecondaryProductSections();
  mobileProductQuery.addEventListener("change", () => {
    arrangeMobileProductDetail();
    alignSecondaryProductSections();
  });

  const removeLegacySealSurface = () => {
    document.querySelectorAll(".template-product [class*='seal'], .template-product [id*='seal'], .template-product [data-seal], .template-product iframe[src*='seal']").forEach((node) => {
      if (!node.closest("[data-sunday-subscription]")) node.remove();
    });
  };
  removeLegacySealSurface();
  const sealObserver = new MutationObserver(removeLegacySealSurface);
  sealObserver.observe(document.body, { childList: true, subtree: true });
  window.setTimeout(() => sealObserver.disconnect(), 20000);

});
